import { NgModule } from '@angular/core';

import { ActionQualityHelperService } from "./action-quality-helper.service";

@NgModule({
    imports: [],
    providers: [ActionQualityHelperService],
})
export class ActionQualityHelperModule {
}
